export class TemplateTypes {
    public static TradeAgreement = "TradeAgreement";
    public static BrokerDetailsRequiredWarning = "BrokerDetailsRequiredWarning";
}